export default "__VITE_ASSET__85d90b27__"